"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socketSettings = void 0;
const messagePaths = {
    activityReached: 'activity_reached',
    activityFinished: 'activity_finished',
    boundaryEventTriggered: 'boundary_event_triggered',
    callActivityReceivedResponse: 'OnFlowNodeCallActivityResponseReceived',
    cronjobCreated: 'cronjob_created',
    cronjobExecuted: 'cronjob_executed',
    cronjobRemoved: 'cronjob_removed',
    cronjobStopped: 'cronjob_stopped',
    cronjobUpdated: 'cronjob_updated',
    emptyActivityWaiting: 'empty_activity_waiting',
    emptyActivityFinished: 'empty_activity_finished',
    externalTaskCreated: 'external_task_created',
    externalTaskLocked: 'external_task_locked',
    externalTaskUnlocked: 'external_task_unlocked',
    flowNodeEntered: 'OnFlowNodeEntered',
    flowNodeExit: 'OnFlowNodeExited',
    flowNodeSuspended: 'OnFlowNodeSuspended',
    flowNodeResumed: 'OnFlowNodeResumed',
    flowNodeError: 'OnFlowNodeError',
    flowNodeTerminated: 'OnFlowNodeTerminated',
    flowNodeTimerStarted: 'OnFlowNodeTimerStarted',
    flowNodeTimerRemoved: 'OnFlowNodeTimerRemoved',
    intermediateThrowEventTriggered: 'intermediate_throw_event_triggered',
    intermediateCatchEventReached: 'intermediate_catch_event_reached',
    intermediateCatchEventFinished: 'intermediate_catch_event_finished',
    manualTaskWaiting: 'manual_task_waiting',
    manualTaskFinished: 'manual_task_finished',
    processDeployed: 'process_deployed',
    processExecutableChanged: 'process_executable_changed',
    // ----
    // TODO - These notifications should be named OnProcessInstance*, to better separate them from the ProcessModel related notifications.
    // Since that is a breaking change, this should be done with the next major update.
    processStarting: 'OnProcessStarting',
    processStarted: 'OnProcessStarted',
    processResumed: 'OnProcessResumed',
    processEnded: 'OnProcessFinished',
    processError: 'OnProcessError',
    processTerminated: 'OnProcessTerminated',
    // ----
    processInstancesDeleted: 'OnProcessInstancesDeleted',
    processUndeployed: 'process_undeployed',
    sendTaskSendMessage: 'OnFlowNodeEventSending',
    sendTaskSendMessageRetry: 'OnFlowNodeEventRetrySending',
    sendTaskReceivedResponse: 'OnFlowNodeEventResponseReceived',
    userTaskWaiting: 'user_task_waiting',
    userTaskFinished: 'user_task_finished',
    userTaskReserved: 'user_task_reserved',
    userTaskReservationCanceled: 'user_task_reservation_canceled',
};
exports.socketSettings = {
    namespace: 'api',
    paths: messagePaths,
};
//# sourceMappingURL=SocketSettings.js.map